<!-- vertical layout -->
<app-vertical *ngIf="isVerticalLayoutRequested()"></app-vertical>

<!-- horizontal layout -->
<app-horizontal *ngIf="isHorizontalLayoutRequested()"></app-horizontal>

<div *ngIf="showWebNotificationMessage"
     class="overLayDiv active"></div>
<div *ngIf="showWebNotificationMessage" id="rightSideBar" class="d-block">
    <div class="rightSidePanel w-55pc d-block">
        <header class="panel-header">
            <div class="viewDemo title-and-video">
                <h2>{{ "information" | translate: param }}</h2>
            </div>
        </header>
        <div class="eod-panel-body-with-footer">
            <div class="block mt-2">
                <h6 class="info-text">
                    <i class="fas fa-exclamation-circle eod-text-danger"></i>
                    <span>
                        {{webNotificationMessage}} {{ 'policy_click_message_part2' | translate}} 
                        <a class="eod-link-primary px-1" href="../../../assets/BrowserSettings.png" target="_blank">{{ 'strip_note2_1' | translate}}</a>
                        {{ 'for_settings' | translate}}
                    </span>
                </h6>
            </div>
        </div>
        <footer class="mt-auto py-1 d-flex justify-content-center align-items-center gap-2 height-60px">
            <button type="button" class="btn eod-btn-outline-warning" (click)="showWebNotificationMessage = false">
                {{ "label_close" | translate: param }}
            </button>
        </footer>
    </div>
</div>